import styled from 'styled-components'

export const GamingContainer = styled.li`
  list-style-type: none;
  display: flex;
  flex-direction: column;

  @media (max-width: 576px){
    flex-direction: column;
    margin-left: 12px;
  }
`

export const GamingImg = styled.img`
  width: 100%;
  height: 400px;
  margin-bottom: 10px;

  @media (max-width: 768px){
    height: 270px;
  }

  @media (max-width: 576px){
    height: 200px;
}
`

export const GamingTitle = styled.p`
  color: ${props => props.color};
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0px;

  @media (max-width: 768px){
  font-size: 15px;
  }
`

export const GamingPara = styled.p`
  color: ${props => props.paraColor};
  font-size: 14px;

  @media (max-width: 768px){
  font-size: 13px;
  }
`
